'use client'

import { Amplify } from 'aws-amplify'
import { parseAmplifyConfig } from 'aws-amplify/utils'

import config from '@/amplify_outputs.json'

let isConfigured = false

const parsedConfig = parseAmplifyConfig(config)
const normalizedConfig = {
  ...parsedConfig,
  API: {
    ...parsedConfig.API,
    REST: config.custom?.API ?? {},
  },
}

export function ensureClientAmplifyConfigured(): void {
  if (isConfigured) return

  Amplify.configure(normalizedConfig, { ssr: true })
  isConfigured = true
}
